module.exports = __webpack_public_path__ + "static/media/agora-logo.dbc84b9a.png";